module.exports = __webpack_public_path__ + "static/img/t5.ba9ccf0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/pic/t5.jpg
// module id = SkqB
// module chunks = 11